import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Modal, Table,Tag, Input, message, Form,Select,InputNumber } from 'antd';
import { http, addVisitLog, history,number as lNumber } from 'libs';
import styles from './layout.module.less'
import { useTranslation } from 'react-i18next';
import store from './store';

export default observer(function () {
  const {t, i18n} = useTranslation()
  const [invoiceCode, setInvoiceCode] = useState();
  const [invoiceTitle, setInvoiceTitle] = useState();
  const [remarks, setRemarks] = useState();
  const [invoices, setInvoices] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);

  useEffect(() => {
    setFetching(true);
    http.post(process.env.REACT_APP_CRM_API_URL+'outApi/invoice/listAll', {accountCode:store.record.organizationCode,maxResult:50})
      .then(res => {
        setInvoices(res.data.result);
        const invoice = res.data.result.find(x => x.is_default);
        if (invoice) {
          setInvoiceCode(invoice.code)
          setInvoiceTitle(invoice.name)
        }
      })
      http.post('/javaApi/front/quote/pushView',{itemIdList:store.ids})
      .then((res) => {
        if (res.data.code===999) {
          const cloneRecords=res.data.result.map(v=>{
            return {
              ...v,
              num:v.actualNumber - v.deliverNumber
            }
          })
          setRecords(cloneRecords)
        } else {
          message.error('获取数据失败')
        }
      })
      .finally(() => setFetching(false))
  }, [])
  function updateNum(info, value, index) {
    Object.assign(records[index], value)
    setRecords([...records])
}

  function handleSubmit() {
    if (!invoiceCode) return message.error('请选择发票信息');
    setLoading(true);
    const itemList = records.map(item => {
      return {
        itemId: item.id,
        number: item.num,
      }
    })
    const params = {itemList: itemList, invoiceCode,invoiceTitle, remarks}
    const url = '/javaApi/front/quote/quoteCreateOrder';
    addVisitLog({
      pageName: '报价单下单',
      fromPageUrl: window.referrerUrl,
      pageUrl:`${window.location.origin}${history.location.pathname}`,
      eventCode: "OrderQuote",
      eventName: "报价单下单",
      content: JSON.stringify(params),
    })
    http.post(url,params)
      .then((res) => {
        message.success('下单成功');
        store.actionVisible = false;
        // store.orderId = res;
        store.ids = [];
        store.quotePage = 1;
        store.quotePageSize = 10;
        store.quotePageTotal = 0;
        store.fetchQuoteRecords()
      }).finally(() => setLoading(false))
  }
  const colorObj={
    "Sale":"#65B1AE",
    "Rent":"#5CA3FE",
    "Store":"#5CA3FE",
    "Testing":"#5CA3FE",
    "Transfer":"#5CA3FE",
    "RentToSale":"#5CA3FE",
  }
  const columns = [ {
    title: '报价单号',
    align:'center',
    dataIndex: 'sn',
    width:160,
  }, {
    title: '品牌',
    align:'center',
    width:200,
    render:(info)=>{
      return (<><Tag color={colorObj[info.catalog]}>
        {t(info?.catalogName?.includes('销')?'购':info?.catalogName?.charAt(0))}
      </Tag>
      {info.goodsInfo.brand}</>)
    }
  },{
    title: '货号',
    width:120,
    align:'center',
    render: info => (
      <span>
        {info.goodsInfo.factoryCode}
      </span>
    )
  }, {
    title: '产品名称',
    align:'center',
    width:160,
    render: info => `${info.goodsInfo.name}`
  },{
    title: '租赁时长',
    align:'center',
    width:100,
    // dataIndex: 'duration',
    // render: value => value ? `${value}个月` : '-'
    render: info => info.goodsInfo.duration?`${info.goodsInfo.duration}个月` : '-'
  }, {
    title: '含税单价',
    align:'center',
    width:100,
    // dataIndex: 'price',
    // render: value => `${value}元`
    render: info => `${info.goodsInfo.price}元`
  }, {
    title: '含税小计',
    align:'center',
    width:100,
    render: info => {
      if (info.num) {
        if (info.catalog==='Rent') {
          if (info.goodsInfo.duration) {
            return `${lNumber.round(lNumber.times(info.num, info.goodsInfo.price,info.goodsInfo.duration), 2)}元`
          }else{
            return '0.00元'
          }
        }else{
          return `${lNumber.round(lNumber.times(info.num, info.goodsInfo.price), 2)}元`
        }
      }else{
        return '0.00'
      }}
  },
  {
    title: '需量/总数',
    width:120,
    align:'center',
    fixed:'right',
    render: (info, _, index) =>
      <div>
        <InputNumber
          value={info.num}
          min={0}
          max={info.actualNumber - info.deliverNumber}
          disabled={info.status!=='0'||(info.actualNumber - info.deliverNumber)===0}
          step={1}
          precision={0}
          style={{ width: 60}}
          size='small'
          onChange={v => updateNum(info, { num: v }, index)} /> / {info.number}
      </div>
  },
]

  return (
    <Modal
      visible
      width={1200}
      maskClosable={false}
      title={`转为销售订单`}
      onCancel={() => store.actionVisible = false}
      confirmLoading={loading}
      onOk={handleSubmit}>
      <Form>
        {/* <Form.Item label="订单备注：">
          <Input autoComplete="off" placeholder="请输入" value={remarks} onChange={e => setRemarks(e.target.value)}/>
        </Form.Item> */}
        <Form.Item required label="选择发票：">
          <Select placeholder="请选择发票" onChange={(value,option)=>{
            setInvoiceCode(value)
            setInvoiceTitle(option.children)
          }} style={{width:250}}>
            {invoices.map(item=>(
            <Select.Option value={item.code}>{item.name}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item>
          <Table
            rowKey="code"
            loading={fetching}
            dataSource={records}
            pagination={false}
            scroll={{ x: 100 }}
            columns={columns}
          >
          </Table>
        </Form.Item>
      </Form>
    </Modal>
  )
})